import { Container } from "@mui/material";
import React from "react";
import Footer from "./Footer";
import lightTheme from "../theme";

export default function FooterView() {
  return (
    <Container maxWidth={false} sx={{display:'flex', justifyContent:'center', paddingTop:'10px',backgroundColor: lightTheme.palette.complementary.main}}>
      <Footer />
    </Container>
  );
}
